import { Command } from "../constants/types/commands";
import { createContext } from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type CommanderFunction = (type: Command, payload: any) => void;

export const commanderContext = createContext<CommanderFunction>(() => {});

export const { Provider } = commanderContext;
